/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './instrument_model';
import '../connect/v2/common/money';
import './common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "banking": {
        "nested": {
          "AccountInstruments": {
            "fields": {
              "bankAccount": {
                "type": ".squareup.banking.BankAccountDetails",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "SavingsAccountMetadata": {
            "fields": {
              "isPrimary": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              },
              "category": {
                "type": ".squareup.banking.SavingsAccountMetadata.Category",
                "id": 2,
                "rule": "optional"
              },
              "sfsAccountId": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "pendingBalance": {
                "type": ".squareup.connect.v2.common.Money",
                "id": 4,
                "rule": "optional"
              },
              "totalBalance": {
                "type": ".squareup.connect.v2.common.Money",
                "id": 5,
                "rule": "optional"
              },
              "isLockedForFreeze": {
                "type": "bool",
                "id": 6,
                "rule": "optional"
              },
              "state": {
                "type": ".squareup.banking.AccountState",
                "id": 7,
                "rule": "optional"
              }
            },
            "nested": {
              "Category": {
                "values": {
                  "UNKNOWN_SAVINGS_ACCOUNT_CATEGORY_DO_NOT_USE": 0,
                  "GENERAL_SAVINGS": 1,
                  "CUSTOM": 2,
                  "TAX": 3,
                  "RAINY_DAY": 4,
                  "RENT": 5,
                  "PAYROLL": 6,
                  "EXPENSE": 7,
                  "RETIREMENT": 8,
                  "PROFIT": 9,
                  "VEHICLE_GAS": 10,
                  "GIVING": 11,
                  "EDUCATION": 12,
                  "SALES_TAX": 13
                }
              }
            }
          },
          "Category": {
            "values": {
              "UNKNOWN_CATEGORY_DO_NOT_USE": 0,
              "GENERAL_SAVINGS": 1,
              "CUSTOM": 2,
              "TAX": 3,
              "RAINY_DAY": 4,
              "RENT": 5,
              "PAYROLL": 6,
              "EXPENSE": 7,
              "RETIREMENT": 8,
              "PROFIT": 9,
              "VEHICLE_GAS": 10,
              "GIVING": 11,
              "EDUCATION": 12
            }
          },
          "FoldersAccountMetadata": {
            "fields": {
              "category": {
                "type": ".squareup.banking.Category",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "AccountMetadata": {
            "fields": {
              "savingsAccount": {
                "type": ".squareup.banking.SavingsAccountMetadata",
                "id": 1
              },
              "foldersAccount": {
                "type": ".squareup.banking.FoldersAccountMetadata",
                "id": 2
              }
            },
            "nested": {
              "data": {
                "oneof": ["savingsAccount", "foldersAccount"]
              }
            }
          },
          "BalanceAmounts": {
            "fields": {
              "availableBalance": {
                "type": ".squareup.connect.v2.common.Money",
                "id": 1,
                "rule": "optional"
              },
              "pendingBalance": {
                "type": ".squareup.connect.v2.common.Money",
                "id": 2,
                "rule": "optional"
              },
              "currentBalance": {
                "type": ".squareup.connect.v2.common.Money",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "Account": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "type": {
                "type": ".squareup.banking.AccountType",
                "id": 2,
                "rule": "optional"
              },
              "availableBalance": {
                "type": ".squareup.connect.v2.common.Money",
                "id": 3,
                "rule": "optional"
              },
              "balanceAmounts": {
                "type": ".squareup.banking.BalanceAmounts",
                "id": 4,
                "rule": "optional"
              },
              "supportedTransferTypes": {
                "type": ".squareup.banking.TransferType",
                "id": 5,
                "rule": "repeated"
              },
              "supportedBalanceTransferDestinationTypes": {
                "type": ".squareup.banking.AccountType",
                "id": 6,
                "rule": "repeated"
              },
              "pendingSettlementTime": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "owner": {
                "type": ".squareup.banking.Owner",
                "id": 8,
                "rule": "optional"
              },
              "state": {
                "type": ".squareup.banking.AccountState",
                "id": 9,
                "rule": "optional"
              },
              "name": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "instruments": {
                "type": ".squareup.banking.AccountInstruments",
                "id": 11,
                "rule": "optional"
              },
              "metadata": {
                "type": ".squareup.banking.AccountMetadata",
                "id": 12,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.banking?.nested?.AccountInstruments && !$root.nested?.squareup?.nested?.banking?.nested?.SavingsAccountMetadata && !$root.nested?.squareup?.nested?.banking?.nested?.SavingsAccountMetadata?.nested?.Category && !$root.nested?.squareup?.nested?.banking?.nested?.Category && !$root.nested?.squareup?.nested?.banking?.nested?.FoldersAccountMetadata && !$root.nested?.squareup?.nested?.banking?.nested?.AccountMetadata && !$root.nested?.squareup?.nested?.banking?.nested?.BalanceAmounts && !$root.nested?.squareup?.nested?.banking?.nested?.Account) {
  $root.addJSON(jsonData);
}

/**
 * A collection of instruments that can be used to access an account.
 *
 * SOURCE AccountInstruments @ squareup/banking/account_model.proto at 16:1
 */
export const AccountInstruments = $root.lookupType('squareup.banking.AccountInstruments');
fixType(AccountInstruments);
Builder.createAndAttachToType(AccountInstruments);
/**
 * SOURCE SavingsAccountMetadata @ squareup/banking/account_model.proto at 20:1
 */
export const SavingsAccountMetadata = $root.lookupType('squareup.banking.SavingsAccountMetadata');
fixType(SavingsAccountMetadata);
Builder.createAndAttachToType(SavingsAccountMetadata);
/**
 * TODO(tugce): We should eventually use banking.account.Category enum
 *
 * SOURCE Category @ squareup/banking/account_model.proto at 22:3
 */
SavingsAccountMetadata.Category = $root.lookupEnum('squareup.banking.SavingsAccountMetadata.Category').values;
/**
 * SOURCE Category @ squareup/banking/account_model.proto at 79:1
 */
export const Category = $root.lookupEnum('squareup.banking.Category').values;
/**
 * SOURCE FoldersAccountMetadata @ squareup/banking/account_model.proto at 95:1
 */
export const FoldersAccountMetadata = $root.lookupType('squareup.banking.FoldersAccountMetadata');
fixType(FoldersAccountMetadata);
Builder.createAndAttachToType(FoldersAccountMetadata);
/**
 * Type-specific metadata for an account.
 *
 * SOURCE AccountMetadata @ squareup/banking/account_model.proto at 107:1
 */
export const AccountMetadata = $root.lookupType('squareup.banking.AccountMetadata');
fixType(AccountMetadata);
Builder.createAndAttachToType(AccountMetadata);
/**
 * SOURCE BalanceAmounts @ squareup/banking/account_model.proto at 115:1
 */
export const BalanceAmounts = $root.lookupType('squareup.banking.BalanceAmounts');
fixType(BalanceAmounts);
Builder.createAndAttachToType(BalanceAmounts);
/**
 * Simplified general view of a account.
 *
 * SOURCE Account @ squareup/banking/account_model.proto at 128:1
 */
export const Account = $root.lookupType('squareup.banking.Account');
fixType(Account);
Builder.createAndAttachToType(Account);